module.exports = __webpack_public_path__ + "static/5-724a3d5cff184db5a593dc689af24e53.jpg";